export enum HubEndpoint {
  Base = '/hubs',
  Enable = '/enable',
  Overview = '/overview',
  LoanerPhones = '/loaner-phones',
  DriverList = '/frequent-drivers',
  SsccId = '/ssccId',
  SecurityQuestions = '/security-questions',
  Trucks = '/trucks',
  Context = '/my',
  Return = '/return',
  ParkingSpots = '/parking-spots',
  Positions = '/positions',
  Search = '/search',
  Exports = '/exports',
}
